import { useState, useEffect } from 'react'
import {
  URL_BACKEND,
  URL_REPORTE_PROMEDIO_RESULTADOS_POR_MATERIA, URL_REPORTE_PROMEDIO_RESULTADOS_POR_CARRERA,
  URL_REPORTE_TODOS_PROMEDIOS_RESULTADOS_POR_CARRERA
} from '../../api/url';
import { elToast } from '../../functions/alertas';


const usePromediosResultados = () => {

  const [loading, setLoading] = useState(true);
  const [carreras, setCarreras] = useState([]);
  const [ciclosExamen, setCiclosExamen] = useState([])
  const [ciclo, setCiclo] = useState('2022-2023')

  const traerCiclosExamen = () => {

    const datos = new FormData()
    datos.append('funcion', 'traerCiclosExamen');

    fetch(URL_BACKEND, {
      method: 'post',
      body: datos
    })
      .then(res => res.json())
      .then(setCiclosExamen)
  }

  const traerCarreras = () => {

    const body = new FormData();
    body.append('funcion', 'traerCarreras')

    fetch(URL_BACKEND, {
      method: 'post',
      body
    })
      .then(r => r.json())
      .then(setCarreras)
      .catch(() => alert('Error al obtener carreras'))
      .finally(() => setLoading(false))

  }


  const reporteGeneralPromediosPorMateria = () => {

    elToast( "Generando reporte", "esperar" );
    const formData = new FormData();
    formData.append("ciclo", ciclo);

    fetch(URL_REPORTE_PROMEDIO_RESULTADOS_POR_MATERIA, {
      method: "POST",
      body: formData
    })
      .then(res => res.blob())
      .then(archivo => {

        const pdf = URL.createObjectURL(archivo);
        // window.open(pdf);

        const anchor = document.createElement("a");
        anchor.download = "PROMEDIO GENERAL DE RESULTADOS DE ASPIRANTES POR MATERIA";
        anchor.href = pdf;
        anchor.click();

      })
      .catch(() => alert('Error en el servidor'))

  }


  // eslint-disable-next-line
  const reportePromedioResultadosPorCarrera = (pk_carrera, nom_carrera) => {

    // eslint-disable-next-line
    const nombre_carrera = nom_carrera.toUpperCase();

    const formData = new FormData();
    formData.append("pk_carrera", pk_carrera);
    formData.append("ciclo", ciclo);

    fetch(URL_REPORTE_PROMEDIO_RESULTADOS_POR_CARRERA, {
      method: "POST",
      body: formData
    })
      .then(res => res.blob())
      .then(archivo => {

        const pdf = URL.createObjectURL(archivo);
        // window.open(pdf);

        const anchor = document.createElement("a");
        // eslint-disable-next-line
        anchor.download = "PROMEDIO GENERAL DE RESULTADOS DE ASPIRANTES - " + nombre_carrera;
        anchor.href = pdf;
        anchor.click();

      })
      .catch(() => alert('Error en el servidor'))

  }


  const reporteTodosPromediosResultadosPorCarrera = () => {


    elToast( "Generando reporte", "esperar" );
    const formData = new FormData();
    formData.append("ciclo", ciclo);

    fetch(URL_REPORTE_TODOS_PROMEDIOS_RESULTADOS_POR_CARRERA, {
      method: "POST",
      body: formData
    })
      .then(res => res.blob())
      .then(archivo => {

        const pdf = URL.createObjectURL(archivo);
        // window.open(pdf);

        const anchor = document.createElement("a");
        anchor.download = "PROMEDIO DE RESULTADOS DE ASPIRANTES POR MATERIA EN CADA CARRERA";
        anchor.href = pdf;
        anchor.click();

      })
      .catch(() => alert('Error en el servidor'))

  }





  useEffect(() => {
    traerCarreras();
    traerCiclosExamen()
  }, [])



  return {
    loading,
    carreras,
    reporteGeneralPromediosPorMateria,
    reportePromedioResultadosPorCarrera,
    reporteTodosPromediosResultadosPorCarrera,
    ciclo, setCiclo, ciclosExamen
  };

}

export default usePromediosResultados;
